// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","adminBar":"_1jj1S","profil":"_2B_CJ","menu":"_3d50_"};